import Vue from 'vue';
import DialogComponent from './dialog.jsx';

import { getAttach } from '../utils/dom';

const createDialog = (props) => {
  const options = { ...props };
  options.visible = true;
  const dialog = new DialogComponent({
    propsData: {
      ...options,
      onClose: options.onClose || (() => {
        dialog.visible = false;
      }),
    },
  }).$mount();
  if (options.className) {
    options.className.split(' ').forEach((name) => {
      dialog.$el.classList.add(name.trim());
    });
  }
  if (options.style) {
    (dialog.$el).style.cssText += options.style;
  }
  const container = getAttach(options.attach);
  if (container) {
    container.appendChild(dialog.$el);
  } else {
    console.error('attach is not exist');
  }

  const dialogNode = {
    show: () => {
      dialog.visible = true;
    },
    hide: () => {
      dialog.visible = false;
    },
    update: (options) => {
      Object.assign(dialog, options);
    },
    destroy: () => {
      dialog.visible = false;
      container.contains(dialog.$el) && container.removeChild(dialog.$el);
    },
  };
  return dialogNode;
};

const confirm = props => createDialog(props);

const alert = (props) => {
  const options = { ...props };
  options.cancel = null;
  return createDialog(options);
};

const extraApi = {
  confirm,
  alert,
};

// eslint-disable-next-line no-underscore-dangle
const _DialogPlugin = {
  install: () => {
    Vue.prototype.$cDialog = createDialog;
    Object.keys(extraApi).forEach((funcName) => {
      Vue.prototype.$cDialog[funcName] = extraApi[funcName];
    });
  },
};

Object.keys(extraApi).forEach((funcName) => {
  _DialogPlugin[funcName] = extraApi[funcName];
});

export const DialogPlugin = _DialogPlugin;
export default DialogPlugin;
